import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './GrowthChallenges.css';
import { useLanguage } from '../../context/LanguageContext';

// Import SVG icons
import shipIcon from '../../images/icons/NewIcons/GrowthChallenges/1-ship.svg';
import puzzleIcon from '../../images/icons/NewIcons/GrowthChallenges/2-puzzle.svg';
import alertIcon from '../../images/icons/NewIcons/GrowthChallenges/3-alert.svg';
import downchartIcon from '../../images/icons/NewIcons/GrowthChallenges/4-downchart.svg';

const GrowthChallenges: React.FC = () => {
  const { t } = useLanguage();

  const steps = [
    {
      number: 1,
      title: t('about.challenges.step1.title'),
      description: t('about.challenges.step1.description'),
      icon: shipIcon,
    },
    {
      number: 2,
      title: t('about.challenges.step2.title'),
      description: t('about.challenges.step2.description'),
      icon: puzzleIcon,
    },
    {
      number: 3,
      title: t('about.challenges.step3.title'),
      description: t('about.challenges.step3.description'),
      icon: alertIcon,
    },
    {
      number: 4,
      title: t('about.challenges.step4.title'),
      description: t('about.challenges.step4.description'),
      icon: downchartIcon,
    },
  ];

  return (
    <section className="growth-challenges-section">
      <Container>
        <div className="challenges-header">
          <p className="challenges-subtitle"></p>
          <h2 className="section-title">{t('about.challenges.title.part1')}</h2>
          <h2 className="section-title challenges-title-highlight">{t('about.challenges.title.part2')}</h2>
        </div>

        <div className="challenges-steps-container">
          <Row className="challenges-steps">
            {steps.map((step, idx) => {
              return (
                <Col lg={3} md={6} xs={12} key={idx} className="challenge-step-col">
                  <div className="challenge-step-card">
                    <div className="step-number-badge">{step.number}</div>
                    <div className="step-icon-container">
                      <img src={step.icon} alt={step.title} className="step-svg-icon" />
                    </div>
                    <h3 className="step-title">{step.title}</h3>
                    <p className="step-description">{step.description}</p>
                  </div>
                  {idx < steps.length - 1 && <div className="step-connector"></div>}
                </Col>
              );
            })}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default GrowthChallenges;
